import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import styles from './box-layout.styles';
import Tooltip from "@mui/material/Tooltip";
import classNames from 'classnames';
import BOX_TYPE from '../enum/box_type';
import { withTranslation } from 'react-i18next';
import groupTypes from '../common/group-types';

let nums2 = Array.from(Array(4).keys());
let nums4 = Array.from(Array(2).keys());
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class CoolLayout extends Component {
    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                if (item) {
                    deactivatedBin.push(item);
                    let node = document.getElementById(item);
                    if (node !== null && node !== undefined) {
                        let x = node.parentNode.classList && node.parentNode.classList[2];
                        node.parentNode.classList.remove(x);
                        let items = document.getElementById(item);
                        if (items && items.style) {
                            items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)';
                            items.style.color = '#fff';
                            items.style.cursor = 'pointer';
                        }
                    }
                }
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                if (item) {
                    var items = document.getElementById(item);
                    if (items && items.style) {
                        items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
                        items.style.color = '#000';
                        items.style.cursor = 'pointer';
                        items.style.pointerEvents = 'all';
                    }
                }
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        if (this.props && this.props.BinStatus.length > 0) {
            this.props.BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    // Extract column ID from bin ID (e.g., "A1" -> "A", "AA1" -> "AA", "A1-A12" -> "A")
    getColumnIdFromBinId = (binId) => {
        if (!binId) return null;
        // Handle formats like "A1", "AA1", "A1-A12", "AA1-AA12"
        const match = binId.match(/^([A-Z]+)\d+/);
        return match ? match[1] : null;
    };

    // Check if bin is restricted by column mappings
    isRestrictedByColumnMapping = (binId) => {
        const { columnMappings, userGroupType } = this.props;
        
        // If no column mappings, not restricted
        if (!columnMappings || !Array.isArray(columnMappings) || columnMappings.length === 0) {
            return false;
        }

        // Extract column ID from bin ID
        const columnId = this.getColumnIdFromBinId(binId);
        if (!columnId) return false;

        // Find the column mapping for this column
        const columnMapping = columnMappings.find(mapping => {
            if (!mapping || !mapping.column_id) return false;
            // Extract column letter from mapping (e.g., "A1-A12" -> "A")
            const mappingColumnId = this.getColumnIdFromBinId(mapping.column_id);
            return mappingColumnId === columnId;
        });

        // If column is mapped:
        // - If user has no group type (null), restrict it (column is assigned to a specific group)
        // - If user has a group type, restrict if it's different from the mapped group
        if (columnMapping && columnMapping.group_type_id) {
            if (!userGroupType) {
                // User has no group type, but column is mapped to a specific group - restrict it
                return true;
            } else if (columnMapping.group_type_id !== userGroupType) {
                // User has a group type, but it's different from the mapped group - restrict it
                return true;
            }
        }

        return false;
    };

    // Combined check: restricted by group type OR column mapping
    isRestricted = (groupTypeId, binId) => {
        // First check existing group type restriction
        if ([
            groupTypes.Retail, 
            groupTypes.Super, 
            groupTypes.eCommerce, 
            groupTypes.Audiology
        ].includes(groupTypeId)) {
            return true;
        }
        // Then check column mapping restriction
        if (this.isRestrictedByColumnMapping(binId)) {
            return true;
        }
        return false;
    };

    // Added by : Manav Pandya
    openbin = (binId, status, pm_id) => {
        // Check if bin is restricted by column mapping - don't allow opening if restricted
        if (this.isRestrictedByColumnMapping(binId)) {
            console.log('[Cool] openbin blocked - bin is restricted by column mapping:', binId);
            return; // Don't allow opening if restricted by column mapping
        }
        
        // Also check combined restriction (group type + column mapping)
        if (this.isRestricted(null, binId)) {
            console.log('[Cool] openbin blocked - bin is restricted (combined check):', binId);
            return;
        }
        
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                let items = document.getElementById(binId);
                items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                items.style.color = '#ffffff'
            }
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            // Handle deactivated bins without status - allow activation
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                this.props.getPrescriptionDetails(binId, pm_id);
                let items = document.getElementById(binId);
                if (items) {
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                    items.style.color = '#ffffff'
                }
            } else {
                BinIds.map((item) => {
                    this.checkIsSaved(item);
                    if (item !== binId && IsSaved === false) {
                        var items = document.getElementById(item);
                        items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
                    }
                    return true
                })
                BinIds = [];
                BinIds.push(binId);
                if (BinIds.length > 0) {
                    this.props.Selectedbin(binId, this.props.box_position, true);
                    var items = document.getElementById(binId);
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)';
                }
            }
        }
    }

    getColumns = (currentIndex, currentColumnCount, previousColumnCount, side) => {
        // getColumns(1, 2, 0, 'left') should return columns
        let columns = [];
        if (side === 'L') {
            for (let i = (previousColumnCount + currentColumnCount); i > previousColumnCount; i--) {
                columns.push(String.fromCharCode(65 + (i - 1)) + String.fromCharCode(65 + (i - 1)))
            }
        } else {
            for (let i = previousColumnCount; i < (previousColumnCount + currentColumnCount); i++) {
                columns.push(String.fromCharCode(65 + (i - 1)))
            }
        }
        return columns;
    }

    // | -3 | -2 | -1 |
    // | 36 |  8 | 60 |
    // | 3  |  2 |  5 |

    // 3 - current Index
    // 7 - Prev Index

    getCurrentAndPreviousPosition = (side) => {
        const { expansion, ExpansionsCounts, boxTypeId } = this.props;
        let response = {};
        response.currentCount = expansion.bin_column_count;
        if (side === 'L') {
            let _expansionsCount = ExpansionsCounts && ExpansionsCounts.leftExpansions;
            if (expansion.box_position === -1 || expansion.box_position === '-1') {
                response.previousCount = 0;
            } else {
                response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount);
            }
        } else {
            let _expansionsCount = ExpansionsCounts.rightExpansions;
            if (expansion.box_position === 1 || expansion.box_position === '1') {
                if (boxTypeId === BOX_TYPE.Locker) {
                    response.previousCount = 6;
                } else {
                    response.previousCount = 4;
                }
            } else {
                if (boxTypeId === BOX_TYPE.Locker) {
                    response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount) + 6;
                } else {
                    response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount) + 4;
                }
            }
        }
        return response;
    }

    excludeCurrentExpansion = (expansion, expansionArray) => {
        let currentUnitIndex = null;
        let sumOfColumns = 0;
        for (let index = 0; index < expansionArray.length; index++) {
            if (expansionArray[index].expansionId === expansion.id) {
                currentUnitIndex = index;
                break;
            }
        }
        for (let i = 0; i < currentUnitIndex; i++) {
            if (expansionArray[i - 1] !== undefined) {
                sumOfColumns = expansionArray[i].bin_column_count + expansionArray[i - 1].bin_column_count;
            } else {
                sumOfColumns = expansionArray[i].bin_column_count;
            }
        }
        return sumOfColumns;
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }

        const { classes, BinStatus, box_position, t, deactivatedBins, isViewPermissionAllowed, PatientID, ADAData } = this.props;
        let elem4 = [];
        let side = box_position < 0 ? 'L' : 'R'
        if (side === 'L') {
            let prevNextCount = this.getCurrentAndPreviousPosition(side);
            let previousExpansionCount = (prevNextCount && prevNextCount.previousCount) ? (prevNextCount.previousCount) : 0;
            elem4 = this.getColumns(box_position, prevNextCount && prevNextCount.currentCount, previousExpansionCount, side);
        } else {
            let prevNextCount = this.getCurrentAndPreviousPosition(side);
            let previousExpansionCount = (prevNextCount && prevNextCount.previousCount) ? (prevNextCount.previousCount) : 0;
            elem4 = this.getColumns(box_position, prevNextCount && prevNextCount.currentCount, previousExpansionCount, side);
        }

        return (
            <div className={classes.ratingContainer} style={{ marginTop: '3rem' }}>
                {nums2.map(n1 => {
                     let doorInx = n1 + 1;
                     const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                         return (
                             item &&
                             item.patient_id === PatientID &&
                             item.ada_compitible === true &&
                             ![2, 3].includes(doorInx)
                         );
                     });
                    return (
                        <Grid
                            key={n1}
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            spacing={8}
                            className={classes.RemoveMargin}
                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                        >
                            {nums4.map(n => {
                                // if (elem4[n] === 'N' || elem4[n] === 'O') {
                                if (this.props && this.props.BinStatus && BinStatus.length > 0) {
                                    let BinKey = elem4[n] + (n1 + 1)
                                    for (var i = 0; i < BinStatus.length; i++) {
                                        let pm_id = BinStatus[i].id;
                                        let isLockedBin = BinStatus[i].is_locked;
                                        if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <Grid
                                                            style={{ padding: '4px', width: '50%', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Stocked', pm_id);
                                                            }}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Stocked")}>
                                                        <Grid
                                                            className={isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool}
                                                            // eslint-disable-next-line
                                                            style={{ padding: '4px', width: '50%',pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Stocked', pm_id);
                                                            }}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridOrangebackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                        else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <Grid
                                                            style={{ padding: '4px', width: '50%', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Assigned', pm_id);
                                                            }}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Assigned")}>
                                                        <Grid
                                                            className={isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool}
                                                            // eslint-disable-next-line
                                                            style={{ padding: '4px', width: '50%',pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin((elem4[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridBluebackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                        else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <Grid
                                                            style={{ padding: '4px', width: '50%', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin(elem4[n] + '' + (n1 + 1), 'Hold', pm_id)}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Hold")}>
                                                        <Grid
                                                            className={isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool}
                                                            // eslint-disable-next-line
                                                            style={{ padding: '4px', pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin((elem4[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                            key={BinKey} item xs={6}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridSkybluebackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                    border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                }}>
                                                                {elem4[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                    }
                                    if (deactivatedBins.length > 0 && deactivatedBins.findIndex((D) => D === (elem4[n] + (n1 + 1))) > -1) {
                                        return (
                                            <Tooltip key={((elem4[n]) + ' ' + (n1 + 1))} title="DEACTIVATE" >
                                                <Grid
                                                    style={{ padding: '4px', width: '50%',pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                    onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                    key={((elem4[n]) + ' ' + (n1 + 1))} item xs={6}>
                                                    <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}>
                                                        {elem4[n] + ' ' + (n1 + 1)}
                                                    </Paper>
                                                </Grid>
                                            </Tooltip>
                                        );
                                    }
                                    else {
                                            return (
                                                <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Available")}>
                                                    <Grid
                                                        className={isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool}
                                                        style={{ padding: '4px', width: '50%',pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                        onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                        key={elem4[n] + ' ' + (n1 + 1)} item xs={6}>
                                                        <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridbackCool, classes.boxLayout)}
                                                            style={{
                                                                // Apply visual styling for column-restricted bins
                                                                backgroundColor: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                border: this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                            }}>
                                                            {elem4[n] + ' ' + (n1 + 1)}
                                                        </Paper>
                                                    </Grid>
                                                </Tooltip>
                                            );
                                        }
                                } else {
                                    return (
                                        <Tooltip key={((elem4[n]) + ' ' + (n1 + 1))} title={t("Global.Prescriptions.Status.Available")}>
                                            <Grid
                                                className={isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool}
                                                style={{ padding: '4px', width: '50%',pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                key={elem4[n] + ' ' + (n1 + 1)} item xs={6}>
                                                <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridbackCool, classes.boxLayout)}>
                                                    {elem4[n] + ' ' + (n1 + 1)}
                                                </Paper>
                                            </Grid>
                                        </Tooltip>
                                    );
                                }
                            })}
                        </Grid>
                    );
                })}
            </div>
        );
    }
}

export default withStyles(styles)(withTranslation()(CoolLayout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Cool-layout.js